/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-01-08 15:07:17
 * @LastEditors: changfeng
 * @LastEditTime: 2024-01-16 11:19:27
 */
import { useState } from "react"
import { ReactComponent as StaffServeIcon } from "@/assets/staffServe.svg"
import { ReactComponent as CompanyWechatIcon } from "@/assets/wechat.svg"
import People from "@/assets/people.jpeg"
import WXCode from "@/assets/WXQRcode.jpg"
import { Image } from "antd"
import styles from "./index.scss"

const CustomerServe = () => {

    const [staffServe, setStaffServe] = useState(false)
    const [companyWechat,setCompanyWeChat] = useState(false)
    return (
        <div className={styles.navFooter}>
            <div className={styles.iconRow}>
                <span className={styles.iconChip} onMouseEnter={() => {setStaffServe(true)}} onMouseLeave={() => {setStaffServe(false)}}><StaffServeIcon color="#fff" /></span>
                <span className={styles.iconChip} onMouseEnter={() => {setCompanyWeChat(true)}} onMouseLeave={() => {setCompanyWeChat(false)}}><CompanyWechatIcon /></span>
            </div>

            {
                staffServe && <div className={styles.popCard}>
                    <p className={styles.popTitle}>有疑问联系客服</p>
                    <p className={styles.popDesc}>请用微信扫一扫</p>
                    <Image src={WXCode}/>
                </div>
            }
            {
                companyWechat && <div className={styles.popCard}>
                    <p className={styles.popTitle}>关注公众号</p>
                    <p className={styles.popDesc}>一手政策实时更新</p>
                    <Image src={People}/>
                </div>
            }
        </div>
    )
}

export default CustomerServe
